export const SINGLE_SEARCH_GET_ALL_SUCCESS = 'SINGLE_SEARCH_GET_ALL_SUCCESS';
export const SINGLE_SEARCH_GET_ALL_FAILURE = 'SINGLE_SEARCH_GET_ALL_FAILURE';
export const SINGLE_SEARCH_DATA_IS_LOADING = 'SINGLE_SEARCH_DATA_IS_LOADING';
